import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import { createRoot } from "react-dom/client";

import { ConfigProvider } from "./contexts/ConfigContext";

import "./index.scss";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
   <React.StrictMode>
      <ConfigProvider>
         <App />
      </ConfigProvider>
   </React.StrictMode>,
);
